import { defineComponent as _defineComponent } from 'vue'
import InvoiceSection from '@/views/my-projects/components/invoice/InvoiceSection.vue';
import BCXForm from '@/components/molecules/forms/BCXForm.vue';
import { BcxFormField } from '@/models/BcxForm';
import { computed, ref } from 'vue';
import useI18n from '@/mixins/useI18n';
import { watchDebounced } from '@vueuse/core';
import useResponsiveness from '@/mixins/useResponsiveness';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceBasisData',
  setup(__props) {

const { t } = useI18n();
const { isMobileWidth } = useResponsiveness();

const horizontalGap = isMobileWidth.value ? '16px' : '40px';

const autoSaveTrigger = ref(0);

const data = ref({
  invoiceType: 'Standard',
  invoiceDate: '2024-12-23',
  invoiceNr: '123456789',
  billingPeriodStart: '2024-11-01',
  billingPeriodEnd: '2024-11-30',
  paymentDeadline: '2025-01-22',
  associatedContract: '123456789',
  reference: 'Reference Title 123456789',
});

const billingPeriodDays = computed(() => {
  if (!data.value.invoiceDate || !data.value.paymentDeadline) {
    return '?';
  }
  const dateStart = new Date(data.value.invoiceDate).getTime();
  const dateEnd = new Date(data.value.paymentDeadline).getTime();
  return Math.ceil((dateEnd - dateStart) / (1000 * 60 * 60 * 24));
});

const fields = computed(() => {
  const invoiceType: BcxFormField = {
    name: 'invoiceType',
    label: `${t('invoice.basis-data.form.invoiceType')}`,
    type: 'plaintext'
  };

  const invoiceDate: BcxFormField = {
    name: 'invoiceDate',
    label: `${t('invoice.basis-data.form.invoiceDate')}`,
    type: 'date'
  };

  const invoiceNr: BcxFormField = {
    name: 'invoiceNr',
    label: `${t('invoice.basis-data.form.invoiceNr')}`,
    type: 'text',
    placeholder: `${t('invoice.basis-data.form.invoiceNrPlaceholder')}`,
    sonderlocke: 'primary-placeholder'
  };

  const billingPeriodStart: BcxFormField = {
    name: 'billingPeriodStart',
    label: `${t('invoice.basis-data.form.billingPeriodStart')}`,
    type: 'date',
    dateOptions: {
      latest: data.value.billingPeriodEnd,
    }
  };

  const billingPeriodEnd: BcxFormField = {
    name: 'billingPeriodEnd',
    label: `${t('invoice.basis-data.form.billingPeriodEnd')}`,
    type: 'date',
    dateOptions: {
      earliest: data.value.billingPeriodStart,
    }
  };

  const paymentDeadline: BcxFormField = {
    name: 'paymentDeadline',
    label: `${t('invoice.basis-data.form.paymentDeadline')}`,
    type: 'date',
    hint: `${t('invoice.basis-data.form.paymentDeadlineHint', { days: billingPeriodDays.value })}`,
  };

  // Felder-Array
  const fields: BcxFormField[] = isMobileWidth.value ? [
    { ...invoiceType, width: '50%' },
    { ...invoiceDate, width: '50%' },

    { ...invoiceNr, width: '50%' },
    { ...paymentDeadline, width: '50%' },

    {
      ...billingPeriodStart,
      width: '50%',
      label: `${t('invoice.basis-data.form.billingPeriodStartMobile')}`,
    },
    { ...billingPeriodEnd, width: '50%' },
  ] : [
    { ...invoiceType, width: '33%' },
    { ...invoiceDate, width: '34%' },
    { ...invoiceNr, width: '33%' },

    { ...billingPeriodStart, width: '33%' },
    { ...billingPeriodEnd, width: '34%' },
    { ...paymentDeadline, width: '33%' },
  ];
  return fields;
});

const referenceFields = computed(() => {
  const fields: BcxFormField[] = [
    {
      name: 'associatedContract',
      label: `${t('invoice.basis-data.form.associatedContract')}`,
      width: isMobileWidth.value ? '50%' : '33%',
      type: 'select',
      options: [] // Contracts
    },
    {
      name: 'reference',
      label: `${t('invoice.basis-data.form.reference')}`,
      width: isMobileWidth.value ? '100%' : '67%',
      type: 'text',
    },
  ];
  return fields;
});

watchDebounced(data, () => {
  autoSaveTrigger.value++;
}, { debounce: 500 });


return { __sfc: true,t, isMobileWidth, horizontalGap, autoSaveTrigger, data, billingPeriodDays, fields, referenceFields, InvoiceSection, BCXForm }
}

})